import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, ActivityIndicator } from 'react-native'
import { Text, Radio, RadioGroup } from '@ui-kitten/components'
import { UserContext } from '../../global/UserProvider'
import * as Sentry from "@sentry/react-native"
import { useTranslation } from 'react-i18next'
import { storesDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import { updateUserStore } from '../../global/Firebase/firebase'

export default function ChooseStoreScreen( { navigation, route } ) {
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const storesDict = useAtomValue(storesDictAtom)
  const [stores, setStores] = useState(null)
  const [storeIndex, setStoreIndex] = useState(null)

  useEffect(() => {
    getStores()
  }, [])

  const getStores = async () => {
    
    var newStores = []
    for (var key in storesDict) {
      newStores.push(storesDict[key])
    }
    for (const [index, value] of newStores.entries()) {
      if (context.user.store?.id === value.id) {
        setStoreIndex(index)
      }
    }
    setStores(newStores)
  }
  
  return (
    <View style={styles.container}>
      <Text status='danger' style={styles.label}>После изменения нужно перезагрузить приложение</Text>
      <Text category='label' style={styles.label}>Выберите филиал</Text>
      <RadioGroup
        selectedIndex={storeIndex}
        onChange={async (index) => {
          setStoreIndex(index)
          try {
            await updateUserStore(context.user.ref, stores[index])
          } catch(error) {
            Sentry.captureException(error)
          }
          
        }}
      >
        { stores ? stores.map((item, index) => (
          <Radio key={item.id} style={styles.radio}>
            {item.name}
          </Radio>
        )) : (
          <View style={{alignItems: 'center'}}><ActivityIndicator /></View>
        )}
      </RadioGroup>
      
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
  },
  label: {
    marginBottom: 5,
    marginTop: 10,
  },
})